import React from "react";
import ItemCar from "./ItemCar";
import Tabs from "./Tab";

function TabCar() {
  let activeTab = window.location.hash.substring(1) || "sedan";

  const sedan = [
    {
      id: "camry",
      name: "Camry",
      price: "1.070.000.000",
      dc: "2.0",
      dt: "1.987",
      slot: 5,
      type: "Số tự động vô cấp CVT",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/448F5CB4E8D6742CF606DA3C605145FA.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/448F5CB4E8D6742CF606DA3C605145FA.png",
    },
    {
      id: "corolla-altis",
      name: "Corolla Altis",
      price: "719.000.000",
      dc: "1.8",
      dt: "1.798",
      slot: 5,
      type: "CVT",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/A670445983E5CD5D91AA647A3BDE2F95.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/A670445983E5CD5D91AA647A3BDE2F95.png",
    },
    {
      id: "vios",
      name: "Vios",
      price: "1.070.000.000",
      dc: "1.5",
      dt: "1.496",
      slot: 5,
      type: " Số tự động vô cấp",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/3B19AD24C38CE54D334BC1DEAF41587D.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/E686F5FF2B31D7E47A2EA60919DA8EEC.png",
    },
  ];

  const hatchBack = [
    {
      id: "wigo",
      name: "Wigo",
      price: "352.000.000",
      dc: "1.2",
      dt: "1.197",
      slot: 5,
      type: "Số sàn 5 cấp",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/24FA8B13C8D4F708F821EE9B1341FFC4.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/96F18F6C714F24A7594859CB068549A7.png",
    },
    {
      id: "yaris",
      name: "Yaris",
      price: "684.000.000",
      dc: "1.5",
      dt: "1.496",
      slot: 5,
      type: "Số tự động vô cấp",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/7BAC1028645009E904340E40AB628EC7.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/55602A483122054C2836FD6346583926.png",
    },
  ];
  const SUV = [
    {
      id: "raize",
      name: "Raize",
      price: "547.000.000",
      dc: "1.0",
      dt: "998",
      slot: 5,
      type: "Vô cấp CVT",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/1052B1A4AE5C2C5809F65C757841A149.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/3B49A305103F09535D8827E3F32A849A.png",
    },
    {
      id: "corolla-cross",
      name: "Corolla Cross",
      price: "746.000.000",
      dc: "1.8",
      dt: "1.798",
      slot: 5,
      type: "Hộp số tự động vô cấp CVT",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/D1169FB589F9EF6122991D894150BCFD.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/DB5C5D661C279C495A9F171014E34F27.png",
    },
    {
      id: "fortuner",
      name: "Fortuner",
      price: "1.015.000.000",
      dc: "2.4",
      dt: "2.393",
      slot: 7,
      type: "Số sàn 6 cấp/6MT",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/5C8A3E6258EEF088D056327796DDCFF7.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/3D86A81BF474C414FD9561C08D35DCA7.png",
    },
    {
      id: "land-prado",
      name: "Land Prado",
      price: "2.588.000.000",
      dc: "2.7",
      dt: "2.694",
      slot: 7,
      type: "Số tự động 6 cấp",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/0B390ABCB353F232D8A16C45781D76BC.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/35777952671ACAAF7A826552421EDC9B.png",
    },
    {
      id: "land-cruiser",
      name: "Land Cruiser",
      price: "4.100.000.000",
      dc: "3.5",
      dt: "3.445",
      slot: 7,
      type: "Số tự động 10 cấp",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/8BAC23774BA5751779B4C5312BD26AED.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/8BAC23774BA5751779B4C5312BD26AED.png",
    },
  ];
  const daDung = [
    {
      id: "alphard",
      name: "Alphard",
      price: "4.280.000.000",
      dc: "3.5",
      dt: "3.456",
      slot: 7,
      type: "Hộp số tự động 8 cấp",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/D4330983565FD6AADDEFC71BDF72B635.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/B99E0C5E4BD43080385C56BDAB62BF62.png",
    },
    {
      id: "innova",
      name: "Innova",
      price: "755.000.000",
      dc: "2.0",
      dt: "1.998",
      slot: 7,
      type: "Số tự động 6 cấp",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/B1C4482978DB18DA2DB5DB1DA1DFF01F.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/CDFDF5294CC6837FAC8ACC8746810C8E.png",
    },
    {
      id: "avanza-premio",
      name: "Avanza Premio",
      price: "548.000.000",
      dc: "1.5",
      dt: "1.496",
      slot: 7,
      type: "CVT",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/4C0BCFB9EA9EF8A9D28FCFDA19D83303.jpg",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/16722B0242352FEBA87ADA38835A52D2.jpg",
    },
    {
      id: "veloz-cross",
      name: "Veloz Cross",
      price: "648.000.000",
      dc: "1.5",
      dt: "1.496",
      slot: 7,
      type: "CVT",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/EDBF83A9C97849C00B8A6B900CE213A5.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/F791B1892243AF2F56533CE0FDB7FFD5.png",
    },
  ];
  const banTai = [
    {
      id: "hilux",
      name: "Hilux",
      price: "628.000.000",
      dc: "2.4",
      dt: "2.393",
      slot: 5,
      type: "Số tay 6 cấp",
      img_url:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/7425FF6EFE5FF8BC0D85AC1ECA003FF7.png",
      img_hover:
        "https://ssa-api.toyotavn.com.vn/Resources/Images/55531401291945AAA32A9E0E3C8D2B36.png",
    },
  ];

  const tabs = [
    {
      id: "sedan",
      title: "Sedan",
      content: (
        <div>
          {sedan.map((item, index) => {
            return <ItemCar item={item} key={index} />;
          })}
        </div>
      ),
    },
    {
      id: "hatchback",
      title: "Hatchback",
      content: (
        <div>
          {hatchBack.map((item, index) => {
            return <ItemCar item={item} key={index} />;
          })}
        </div>
      ),
    },
    {
      id: "suv",
      title: "SUV",
      content: (
        <div>
          {SUV.map((item, index) => {
            return <ItemCar item={item} key={index} />;
          })}
        </div>
      ),
    },
    {
      id: "da-dung",
      title: "Đa dụng",
      content: (
        <div>
          {daDung.map((item, index) => {
            return <ItemCar item={item} key={index} />;
          })}
        </div>
      ),
    },
    {
      id: "ban-tai",
      title: "Bán tải",
      content: (
        <div>
          {banTai.map((item, index) => {
            return <ItemCar item={item} key={index} />;
          })}
        </div>
      ),
    },
  ];
  return (
    <section className="w3l-specification-6">
      <div className="specification-6-mian py-5">
        <div className="container py-lg-4">
          <div className="title-content text-center mb-lg-5 mt-4">
            <h3
              className="hny-title"
              style={{
                fontFamily:
                  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              }}
            >
              KHÁM PHÁ CÁC DÒNG XE TOYOTA
            </h3>
          </div>
          <div className="row story-6-grids text-left">
            <Tabs
              tabs={tabs}
              activeTab={activeTab}
              classNameUL="nav-full-with"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default TabCar;
